import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, mapMany, isSubset, setEquals } from "keautils";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";
import { observeResource } from "kea-resource";

import { FiltroComponent } from "./filtro";
import { MulticlienteSugerenciaComp } from "./multiclientecomp";

export interface Props {
    /**Folios de las guias seleccionadas */
    value: string[];
    onChange: (x: string[]) => void;
    filtro: models.FiltroGuiasContrarecibos;
    onFiltroChange: (x: models.FiltroGuiasContrarecibos) => void;
    sugerencia?: models.ContrareciboSugeridoModel[];
    loading?: boolean;
}

/**Devuelve true si hay alguna guia seleccionada que no forme parte de la sugerencia */
function hayGuiasFueraFiltro(guias: string[], sugerencia: models.ContrareciboSugeridoModel[]) {
    const guiasSugerencia = getTodasGuias(sugerencia);
    return !isSubset(guiasSugerencia, guias);
}

/**Obtiene todos los folios sugeridos */
function getTodasGuias(sugerencia: models.ContrareciboSugeridoModel[]) {
    const todas = mapMany(sugerencia, x => x.Guias).map(x => x.Folio);
    return todas;
}

function getEstanTodas(guias: string[], sugerencia: models.ContrareciboSugeridoModel[]) {
    return setEquals(getTodasGuias(sugerencia), guias);
}
function getEstanNinguna(guias: string[]) {
    return guias.length == 0;
}

class CrearContrarecibosFormNoRx extends React.PureComponent<Props> {
    constructor(props: Props) {
        props.filtro.EsGuiaLogistica = false;
        super(props);
        this.state = { filtro: {} }
    }

    sugerencia = (x: Props) => x.sugerencia || [];

    onTodas = () => {
        this.props.onChange(getTodasGuias(this.sugerencia(this.props)));
    }
    onNinguna = () => {
        this.props.onChange([]);
    }

    render() {
        const sugerencia = this.sugerencia(this.props);
        const guiasFueraFiltro = hayGuiasFueraFiltro(this.props.value, sugerencia);
        const estanTodas = getEstanTodas(this.props.value, sugerencia);
        const estanNinguna = getEstanNinguna(this.props.value);
        const cantidadSeleccionada = this.props.value.length;
        const cantidadTotal = getTodasGuias(sugerencia).length;
        return (
            <div>
                <div className="btn-group">
                    <kea.Button onClick={this.onTodas} style={estanTodas ? "info" : "default"} iconClass={fa("check-square-o")} />
                    <kea.Button onClick={this.onNinguna} style={estanNinguna ? "info" : "default"} iconClass={fa("square-o")} />
                    ({cantidadSeleccionada}/{cantidadTotal})
                </div>

                <FiltroComponent value={this.props.filtro} onChange={this.props.onFiltroChange} />

                {
                    guiasFueraFiltro &&
                    <div className="alert alert-danger">
                        Existen guias seleccionadas que no forman parte de las guias filtradas
                    </div>
                }

                {this.props.loading && <kea.Spinner />}
                <MulticlienteSugerenciaComp sugerencias={this.sugerencia(this.props)} onSeleccionar={this.props.onChange} guias={this.props.value} />
            </div>
        )
    }
}

export const CrearContrarecibosForm = componentToRx(CrearContrarecibosFormNoRx, undefined, undefined, {
    loading: { loading: true }
});


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibos/form.tsx